import { render, staticRenderFns } from "./TerminalsTable.vue?vue&type=template&id=8d97d388&scoped=true"
import script from "./TerminalsTable.vue?vue&type=script&lang=js"
export * from "./TerminalsTable.vue?vue&type=script&lang=js"
import style0 from "./TerminalsTable.vue?vue&type=style&index=0&id=8d97d388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d97d388",
  null
  
)

export default component.exports